/* ============================================
   SWEETNY WELLNESS — THEME JS
   ============================================ */

/* ── CART STATE ── */
let cart = { items: [], total: 0 };

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2) + ' CAD';
}

/* ── LANGUAGE ── */
const i18n = {
  en: {
    topbar: ['✦ Free shipping over $100 CAD','✦ Join the Loyalty Club & earn rewards','✦ New: Bloom Collection — Shop Now','✦ Easy returns & exchanges','✦ Proudly Canadian 🇨🇦'],
    nav: { shop:'Shop', newIn:'New In', leggings:'Leggings', shorts:'Shorts', bras:'Sports Bras', tops:'Tops', collections:'Collections', loyalty:'Loyalty Club', about:'About Us' },
    cats: ['All','New In','Leggings','Shorts','Sports Bras','Tops','Bloom','Empower','Best Sellers'],
    hero: { eyebrow:'SS26 — New Collection', headline:'Wear Your<br><em>Power</em>', cta1:'Shop the Collection', cta2:'Bloom Collection', badge1:'New Colours', badge2:'From $28' },
    newReleases: { eyebrow:'Just Dropped', title:'New <em>Releases</em>', viewAll:'View all →' },
    badgeNew: 'New', badgeBest: 'Best Seller', quickAdd: 'Quick Add',
    collectionsEyebrow: 'Curated for You', collectionsTitle: 'Shop by <em>Collection</em>',
    colBloomLabel:'New Drop', colBloomName:'Bloom<br>Collection',
    colEmpowerLabel:'Core Line', colEmpowerName:'Empower<br>Series',
    colShortsLabel:'Category', colShortsName:'Seamless<br>Shorts',
    colShopNow: 'Shop Now',
    perks: [
      {title:'Free Shipping', sub:'On all orders over $100 CAD'},
      {title:'Easy Returns', sub:'Hassle-free 30-day returns'},
      {title:'Secure Checkout', sub:'SSL encrypted payments'},
      {title:'Made for Women', sub:'Designed by women, for women'}
    ],
    storyEyebrow: 'My Story',
    storyTitle: 'Built for Women<br>On the <em>Move</em>',
    storyBody1: "Sweetny Wellness started as a personal solution and grew into something so much bigger. It became a community-driven brand built on one simple belief: that feeling strong, confident, and beautiful should never come with an unaffordable price tag. My mission is to make premium activewear accessible to everyone because wellness isn't a luxury, it's a right. Every woman, every body, every budget deserves to show up and feel incredible. Because your wellness journey shouldn't have to wait for your budget to catch up.",
    storyBody2: "Each piece is crafted with purpose-built fabrics that sculpt and support the way you move, because what you wear should feel as intentional as the life you're building. At Sweetny Wellness, I don't just create activewear. I create reminders that your body is your home, your strength is your story, and your wellness is worth celebrating every single day.",
    storyTags: ['Seamless Technology','Canadian Brand','Size Inclusive','Sculpting Fit'],
    storyCta1: 'My Story',
    storyCta2: 'Shop All',
    testiEyebrow: 'Real Women, Real Results',
    testiTitle: "What They're <em>Saying</em>",
    testimonials: [
      { text: '"These shorts are absolutely incredible. The seamless fit hugs every curve I\'ve never felt so confident at the gym."', author: '— Camille B., Montréal' },
      { text: '"The aqua set arrived and the colour is even more stunning in person. Quality is top notch!"', author: ' Jasmine T., Toronto' },
      { text: '"Finally a Canadian brand that gets women\'s bodies. The Empower Series leggings are my new go-to."', author: ' Sarah M., Vancouver' },
      { text: '"Ordered the fuchsia set and I\'m obsessed. The long sleeve crop is so flattering. Fast shipping too!"', author: ' Alyssa R., Calgary' },
      { text: '"The black set is perfect for heavy lifting days. Holds everything in and the scrunch back is chef\'s kiss."', author: ' Priya K., Ottawa' }
    ],
    instaTitle: 'Follow the <em>Movement</em>',
    instaView: 'View Post',
    loyaltyEyebrow: 'Members Only',
    loyaltyTitle: 'Join the<br><em>Loyalty Club</em>',
    loyaltyBody: 'Earn points on every purchase, unlock exclusive discounts, and be the first to access new drops. Your wellness journey — rewarded.',
    loyaltyStats: [{ num:'1×', label:'Points per $1' }, { num:'10%', label:'Member discount' }, { num:'Early', label:'New drop access' }],
    loyaltyCta: "Join Now — It's Free",
    emailHint: 'Or enter your email to get 10% off your first order',
    emailPlaceholder: 'your@email.com',
    emailBtn: 'Claim',
    footerDesc: 'Premium Canadian women\'s activewear designed for confidence, comfort, and movement. Every rep. Every day.',
    footerShop: 'Shop',
    footerHelp: 'Help',
    footerCompany: 'Company',
    footerShopLinks: [
      ['All Products','/collections/all'],
      ['Bloom Collection','/collections/bloom-collection'],
      ['Empower Series','/collections/empower-series'],
      ['Leggings','/collections/leggings'],
      ['Shorts','/collections/shorts'],
      ['Sports Bras','/collections/sports-bras'],
      ['Tops','/collections/tops']
    ],
    footerHelpLinks: [
      ['Shipping & Delivery','/pages/shipping-policy'],
      ['Returns & Exchanges','/pages/returns-exchanges-policy'],
      ['Size Guide','/pages/sizing-chart'],
      ['FAQ','/pages/faq'],
      ['Contact Us','/pages/contact'],
      ['Track My Order','/pages/track-your-order']
    ],
    footerCompanyLinks: [
      ['About Us','/pages/about'],
      ['Loyalty Club','/pages/loyalty-club'],
      ['Partner with Us','/blogs/news/partner-with-us'],
      ['Blog','/blogs/news'],
      ['Privacy Policy','/pages/data-sharing-opt-out'],
      ['Terms of Service','/pages/terms-of-service']
    ],
    footerCopy: '© 2026 Sweetny Wellness Canada. All rights reserved.',
    cartTitle: 'Your Cart',
    cartEmpty: 'Your cart is empty',
    cartContinue: 'Continue Shopping',
    cartCheckout: 'Checkout',
    cartSubtotal: 'Subtotal',
    cartNote: 'Shipping calculated at checkout',
    searchPlaceholder: 'Search for products…',
    searchHint: 'Popular: Leggings, Sports Bras, Bloom Collection',
    addedToCart: 'Added to cart',
    lang: 'English'
  },

  fr: {
    topbar: ['✦ Livraison gratuite dès 100 $ CAD','✦ Rejoins le Club de fidélité & cumule des récompenses','✦ Nouveau : Collection Bloom — Magasine','✦ Retours faciles & échanges','✦ Fièrement canadien 🇨🇦'],
    nav: { shop:'Boutique', newIn:'Nouveautés', leggings:'Leggings', shorts:'Shorts', bras:'Brassières', tops:'Hauts', collections:'Collections', loyalty:'Club de fidélité', about:'À propos' },
    cats: ['Tout','Nouveautés','Leggings','Shorts','Brassières','Hauts','Bloom','Empower','Meilleures ventes'],
    hero: { eyebrow:'PE26 — Nouvelle Collection', headline:'Porte ta<br><em>Force</em>', cta1:'Magasiner la collection', cta2:'Collection Bloom', badge1:'Nouvelles couleurs', badge2:'Dès 28 $' },
    newReleases: { eyebrow:'Tout juste arrivé', title:'Nouvelles <em>Arrivées</em>', viewAll:'Voir tout →' },
    badgeNew: 'Nouveau',
    badgeBest: 'Meilleure vente',
    quickAdd: 'Ajout rapide',
    collectionsEyebrow: 'Sélectionné pour toi',
    collectionsTitle: 'Magasiner par <em>Collection</em>',
    colBloomLabel:'Nouveau drop',
    colBloomName:'Collection<br>Bloom',
    colEmpowerLabel:'Ligne principale',
    colEmpowerName:'Série<br>Empower',
    colShortsLabel:'Catégorie',
    colShortsName:'Shorts<br>sans coutures',
    colShopNow: 'Magasiner',
    perks: [
      {title:'Livraison gratuite', sub:'Pour toute commande de plus de 100 $ CAD'},
      {title:'Retours faciles', sub:'Retours sans tracas sous 30 jours'},
      {title:'Paiement sécurisé', sub:'Paiements chiffrés SSL'},
      {title:'Fait pour les femmes', sub:'Conçu par des femmes, pour des femmes'}
    ],
    storyEyebrow: 'Notre histoire',
    storyTitle: 'Fait pour les femmes<br>qui <em>bougent</em>',
    storyBody1: 'Sweetny Wellness est née au Canada avec une conviction : chaque femme mérite de se sentir puissante dans ce qu\'elle porte. Nous créons des vêtements de sport sans coutures premium.',
    storyBody2: 'Chaque pièce est conçue avec des tissus techniques qui sculptent, soutiennent et respirent. Des couleurs audacieuses. Des coupes réfléchies. Une vraie confiance en soi.',
    storyTags: ['Technologie sans coutures','Marque canadienne','Toutes les tailles','Coupe sculptante'],
    storyCta1: 'Notre histoire',
    storyCta2: 'Tout magasiner',
    testiEyebrow: 'Vraies femmes, vrais résultats',
    testiTitle: 'Ce qu\'elles <em>disent</em>',
    testimonials: [
      { text: '"Ces shorts sont absolument incroyables. La coupe sans coutures épouse chaque courbe  je ne me suis jamais sentie aussi confiante."', author: ' Camille B., Montréal' },
      { text: '"L\'ensemble aqua est arrivé et la couleur est encore plus belle en vrai. La qualité est top notch!"', author: ' Jasmine T., Toronto' },
      { text: '"Enfin une marque canadienne qui comprend vraiment le corps des femmes. Les leggings Empower sont devenus mon incontournable."', author: ' Sarah M., Vancouver' },
      { text: '"J\'ai commandé l\'ensemble fuchsia et je suis obsédée. Le crop à manches longues est tellement flatteur!"', author: ' Alyssa R., Calgary' },
      { text: '"L\'ensemble noir est parfait pour les entraînements intenses. Tout est maintenu en place et le dos scrunch est une tuerie."', author: ' Priya K., Ottawa' }
    ],
    instaTitle: 'Suis le <em>mouvement</em>',
    instaView: 'Voir la publication',
    loyaltyEyebrow: 'Membres seulement',
    loyaltyTitle: 'Rejoins le<br><em>Club de fidélité</em>',
    loyaltyBody: 'Cumule des points à chaque achat, débloque des rabais exclusifs et sois la première à accéder aux nouveaux drops. Ton parcours bien-être récompensé.',
    loyaltyStats: [{ num:'1×', label:'Points par 1 $' }, { num:'10%', label:'Rabais membre' }, { num:'Accès', label:'Prioritaire aux drops' }],
    loyaltyCta: 'Rejoindre — c\'est gratuit',
    emailHint: 'Ou entre ton courriel pour obtenir 10 % de rabais sur ta première commande',
    emailPlaceholder: 'ton@courriel.com',
    emailBtn: 'Obtenir',
    footerDesc: 'Vêtements de sport féminins canadiens haut de gamme conçus pour la confiance, le confort et le mouvement. Chaque répétition. Chaque jour.',
    footerShop: 'Boutique',
    footerHelp: 'Aide',
    footerCompany: 'Entreprise',
    footerShopLinks: [
      ['Tous les produits','/collections/all'],
      ['Collection Bloom','/collections/bloom-collection'],
      ['Série Empower','/collections/empower-series'],
      ['Leggings','/collections/leggings'],
      ['Shorts','/collections/shorts'],
      ['Brassières de sport','/collections/sports-bras'],
      ['Hauts','/collections/tops']
    ],
    footerHelpLinks: [
      ['Livraison & expédition','/pages/shipping-policy'],
      ['Retours & échanges','/pages/returns-exchanges-policy'],
      ['Guide des tailles','/pages/sizing-chart'],
      ['FAQ','/pages/faq'],
      ['Nous contacter','/pages/contact'],
      ['Suivre ma commande','/pages/track-your-order']
    ],
    footerCompanyLinks: [
      ['À propos','/pages/about'],
      ['Club de fidélité','/pages/loyalty-club'],
      ['Partenariat','/blogs/news/partner-with-us'],
      ['Blogue','/blogs/news'],
      ['Politique de confidentialité','/pages/data-sharing-opt-out'],
      ['Conditions d\'utilisation','/pages/terms-of-service']
    ],
    footerCopy: '© 2026 Sweetny Wellness Canada. Tous droits réservés.',
    cartTitle: 'Votre panier',
    cartEmpty: 'Votre panier est vide',
    cartContinue: 'Continuer les achats',
    cartCheckout: 'Passer à la caisse',
    cartSubtotal: 'Sous-total',
    cartNote: 'Frais d\'expédition calculés au moment du paiement',
    searchPlaceholder: 'Rechercher des produits…',
    searchHint: 'Populaire : Leggings, Brassières, Collection Bloom',
    addedToCart: 'Ajouté au panier',
    lang: 'Français'
  }
};

/* ── LANGUAGE STATE ── */
let lang = localStorage.getItem('sw_lang') || ((navigator.language || '').toLowerCase().startsWith('fr') ? 'fr' : 'en');

function t(key) {
  return i18n[lang][key] || i18n.en[key] || '';
}

function setLang(l) {
  lang = l;
  localStorage.setItem('sw_lang', l);
  renderPage();
  refreshCart();
}

/* ── PRODUCTS DATA ── */
const products = [
  {
    id: 1,
    name_en: 'Aqua Cross Back Bra',
    name_fr: 'Brassière dos croisé Aqua',
    price: 2800,
    badge: 'new',
    img: 'https://sweetnywellness.com/cdn/shop/files/aquaposeee.png',
    img2: 'https://sweetnywellness.com/cdn/shop/files/blackpose.png',
    colors: ['#2ac8e8', '#e8558a', '#1a1a1a'],
    href: '/products/aqua-cross-back-bra'
  },
  {
    id: 2,
    name_en: 'Fuchsia Long Sleeve Crop Top',
    name_fr: 'Haut crop manches longues Fuchsia',
    price: 3500,
    badge: 'new',
    img: 'https://sweetnywellness.com/cdn/shop/files/fuchasiabacktop.png',
    img2: 'https://sweetnywellness.com/cdn/shop/files/frontlemontop.png',
    colors: ['#e8558a', '#f2e84a', '#1a1a1a'],
    href: '/products/fuchsia-long-sleeve-top'
  },
  {
    id: 3,
    name_en: 'Lemon Twist Crop Top',
    name_fr: 'Haut crop torsadé Citron',
    price: 3500,
    badge: 'new',
    img: 'https://sweetnywellness.com/cdn/shop/files/frontlemontop.png',
    img2: 'https://sweetnywellness.com/cdn/shop/files/fuchasiabacktop.png',
    colors: ['#f2e84a', '#2ac8e8'],
    href: '/products/lemon-cross-back-bra'
  },
  {
    id: 4,
    name_en: 'Midnight Seamless Set',
    name_fr: 'Ensemble sans coutures Minuit',
    price: 2800,
    badge: 'bestseller',
    img: 'https://sweetnywellness.com/cdn/shop/files/blackpose.png',
    img2: 'https://sweetnywellness.com/cdn/shop/files/aquaposeee.png',
    colors: ['#1a1a1a', '#2ac8e8', '#e8558a'],
    href: '/products/midnight-seamless-shorts'
  },
  {
    id: 5,
    name_en: 'Aqua Long Sleeve Top',
    name_fr: 'Haut manches longues Aqua',
    price: 3500,
    badge: 'new',
    img: 'https://sweetnywellness.com/cdn/shop/files/aquaposeee.png',
    img2: 'https://sweetnywellness.com/cdn/shop/files/blackpose.png',
    colors: ['#2ac8e8', '#1a1a1a'],
    href: '/products/aqua-long-sleeve-top'
  },
  {
    id: 6,
    name_en: 'Lavender Cross Back Bra',
    name_fr: 'Brassière dos croisé Lavande',
    price: 2800,
    badge: 'new',
    img: 'https://sweetnywellness.com/cdn/shop/files/fuchasiabacktop.png',
    img2: 'https://sweetnywellness.com/cdn/shop/files/frontlemontop.png',
    colors: ['#c8a8e8', '#e8558a', '#f2e84a'],
    href: '/products/lavender-cross-back-bra'
  },
  {
    id: 7,
    name_en: 'Midnight Long Sleeve Crop Top',
    name_fr: 'Haut crop manches longues Minuit',
    price: 3500,
    badge: 'bestseller',
    img: 'https://sweetnywellness.com/cdn/shop/files/blackpose.png',
    img2: 'https://sweetnywellness.com/cdn/shop/files/aquaposeee.png',
    colors: ['#1a1a1a'],
    href: '/products/midnight-long-sleeve-crop-top'
  },
  {
    id: 8,
    name_en: 'Fuchsia Seamless Shorts',
    name_fr: 'Shorts sans coutures Fuchsia',
    price: 2800,
    badge: 'new',
    img: 'https://sweetnywellness.com/cdn/shop/files/fuchasiabacktop.png',
    img2: 'https://sweetnywellness.com/cdn/shop/files/blackpose.png',
    colors: ['#e8558a', '#1a1a1a', '#2ac8e8'],
    href: '/products/fuchsia-seamless-shorts'
  }
];

/* ── RENDER ENGINE ── */
function renderPage() {
  const d = document;
  const T = i18n[lang];

  d.documentElement.lang = lang;

  if (d.title) {
    d.title = lang === 'fr'
      ? 'Sweetny Wellness — Vêtements de sport féminins'
      : 'Sweetny Wellness — Women\'s Activewear';
  }

  d.querySelectorAll('.lang-btn').forEach(b => {
    b.classList.toggle('active', b.dataset.lang === lang);
  });

  const tb = d.getElementById('topbarTrack');
  if (tb) {
    const items = [...T.topbar, ...T.topbar];
    tb.innerHTML = items.map(s => `<span>${s}</span>`).join('');
  }

  const navLinks = d.getElementById('navLinks');
  if (navLinks) {
    navLinks.innerHTML = `
      <li class="nav__item">
        <a href="/collections/all" class="nav__link nav__link--active">
          ${T.nav.shop}
          <svg viewBox="0 0 24 24"><polyline points="6 9 12 15 18 9"/></svg>
        </a>

        <div class="nav__mega">
          <div class="nav__mega-inner">
            <div class="nav__mega-col">
              <div class="nav__mega-col-title">${lang === 'fr' ? 'Nouveautés' : 'New Releases'}</div>
              <ul>
                <li><a href="/collections/bloom-collection">${lang === 'fr' ? 'Collection Bloom' : 'Bloom Collection'}</a></li>
                <li><a href="/collections/empower-series">${lang === 'fr' ? 'Série Empower' : 'Empower Series'}</a></li>
              </ul>
            </div>

            <div class="nav__mega-col">
              <div class="nav__mega-col-title">${lang === 'fr' ? 'Catégorie' : 'Category'}</div>
              <ul>
                <li><a href="/collections/all">${lang === 'fr' ? 'Tous les produits' : 'Shop All'}</a></li>
                <li><a href="/collections/leggings">${T.nav.leggings}</a></li>
                <li><a href="/collections/shorts">${T.nav.shorts}</a></li>
                <li><a href="/collections/sports-bras">${T.nav.bras}</a></li>
                <li><a href="/collections/tops">${T.nav.tops}</a></li>
              </ul>
            </div>

            <div class="nav__mega-col">
              <div class="nav__mega-col-title">${T.nav.collections}</div>
              <ul>
                <li><a href="/collections/bloom-collection">${lang === 'fr' ? 'Collection Bloom' : 'Bloom Collection'}</a></li>
                <li><a href="/collections/empower-series">${lang === 'fr' ? 'Série Empower' : 'Empower Series'}</a></li>
              </ul>
            </div>

            <div class="nav__mega-col">
              <div class="nav__mega-col-title">${lang === 'fr' ? 'Magasiner par couleur' : 'Shop by Colour'}</div>
              <ul>
                <li><a href="/collections/all?color=aqua">Aqua</a></li>
                <li><a href="/collections/all?color=fuchsia">Fuchsia</a></li>
                <li><a href="/collections/all?color=lemon">${lang === 'fr' ? 'Citron' : 'Lemon'}</a></li>
                <li><a href="/collections/all?color=midnight">${lang === 'fr' ? 'Minuit' : 'Midnight'}</a></li>
                <li><a href="/collections/all?color=lavender">${lang === 'fr' ? 'Lavande' : 'Lavender'}</a></li>
              </ul>
            </div>
          </div>
        </div>
      </li>

      <li class="nav__item"><a href="/pages/about" class="nav__link">${T.nav.about}</a></li>
      <li class="nav__item"><a href="/pages/loyalty-club" class="nav__link">${T.nav.loyalty}</a></li>
      <li class="nav__item"><a href="/blogs/news" class="nav__link">${lang === 'fr' ? 'Blogue' : 'Blog'}</a></li>
    `;
  }

  const mobileLinks = d.getElementById('mobileLinks');
  if (mobileLinks) {
    mobileLinks.innerHTML = `
      <a href="/collections/all" class="mobile-nav__link">${T.nav.shop}</a>
      <div class="mobile-nav__sub-title">${lang === 'fr' ? 'Catégorie' : 'Category'}</div>
      <a href="/collections/leggings" class="mobile-nav__sub-link">${T.nav.leggings}</a>
      <a href="/collections/shorts" class="mobile-nav__sub-link">${T.nav.shorts}</a>
      <a href="/collections/sports-bras" class="mobile-nav__sub-link">${T.nav.bras}</a>
      <a href="/collections/tops" class="mobile-nav__sub-link">${T.nav.tops}</a>
      <div class="mobile-nav__sub-title">${T.nav.collections}</div>
      <a href="/collections/bloom-collection" class="mobile-nav__sub-link">${lang === 'fr' ? 'Collection Bloom' : 'Bloom Collection'}</a>
      <a href="/collections/empower-series" class="mobile-nav__sub-link">${lang === 'fr' ? 'Série Empower' : 'Empower Series'}</a>
      <a href="/pages/about" class="mobile-nav__link">${T.nav.about}</a>
      <a href="/pages/loyalty-club" class="mobile-nav__link">${T.nav.loyalty}</a>
      <a href="/blogs/news" class="mobile-nav__link">${lang === 'fr' ? 'Blogue' : 'Blog'}</a>
    `;
  }

  setHTML('heroEyebrow', T.hero.eyebrow);
  setHTML('heroHeadline', T.hero.headline);
  setHTML('heroCta1', T.hero.cta1);
  setHTML('heroCta2', T.hero.cta2);
  setHTML('heroBadge1', T.hero.badge1);
  setHTML('heroBadge2', T.hero.badge2);

  const filterBar = d.getElementById('filterBar');
  if (filterBar) {
    filterBar.innerHTML = T.cats.map((c, i) =>
      `<div class="filter-pill${i === 0 ? ' active' : ''}" data-cat="${c}">${c}</div>`
    ).join('');

    filterBar.querySelectorAll('.filter-pill').forEach(p => {
      p.addEventListener('click', () => {
        filterBar.querySelectorAll('.filter-pill').forEach(x => x.classList.remove('active'));
        p.classList.add('active');
      });
    });
  }

  const pg = d.getElementById('productGrid');
  if (pg) {
    const badge = { new: T.badgeNew, bestseller: T.badgeBest };

    pg.innerHTML = products.map(p => `
      <div class="product-card" data-id="${p.id}">
        <div class="product-card__media">
          <img class="product-card__img" src="${p.img}" alt="${lang === 'fr' ? p.name_fr : p.name_en}" loading="lazy" />
          <img class="product-card__img--hover" src="${p.img2}" alt="" loading="lazy" />

          ${p.badge ? `<span class="product-card__badge product-card__badge--${p.badge}">${badge[p.badge]}</span>` : ''}

          <div class="product-card__wish" title="${lang === 'fr' ? 'Ajouter aux favoris' : 'Add to wishlist'}">
            <svg viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
          </div>

          <div class="product-card__quick" data-id="${p.id}">${T.quickAdd}</div>
        </div>

        <div class="product-card__info">
          <p class="product-card__name">
            <a href="${p.href}">${lang === 'fr' ? p.name_fr : p.name_en}</a>
          </p>

          <p class="product-card__price">
            <strong>${formatMoney(p.price)}</strong>
          </p>

          <div class="product-card__colors">
            ${p.colors.map(c => `<div class="color-swatch" style="background:${c}" title="${c}"></div>`).join('')}
          </div>
        </div>
      </div>
    `).join('');

    pg.querySelectorAll('.product-card__quick').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();

        const pid = +btn.dataset.id;
        const prod = products.find(p => p.id === pid);

        if (prod) {
          addToCart(prod, lang);
        }
      });
    });
  }

  setHTML('newReleasesEyebrow', T.newReleases.eyebrow);
  setHTML('newReleasesTitle', T.newReleases.title);
  setInner('newReleasesViewAll', T.newReleases.viewAll);

  setHTML('collectionsEyebrow', T.collectionsEyebrow);
  setHTML('collectionsTitle', T.collectionsTitle);
  setHTML('colBloomLabel', T.colBloomLabel);
  setHTML('colBloomName', T.colBloomName);
  setHTML('colEmpowerLabel', T.colEmpowerLabel);
  setHTML('colEmpowerName', T.colEmpowerName);
  setHTML('colShortsLabel', T.colShortsLabel);
  setHTML('colShortsName', T.colShortsName);

  d.querySelectorAll('.col-shopnow').forEach(el => {
    el.textContent = T.colShopNow;
  });

  const perksGrid = d.getElementById('perksGrid');
  if (perksGrid) {
    const icons = [
      '<path d="M5 12h14M12 5l7 7-7 7"/>',
      '<polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-4.5"/>',
      '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>',
      '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>'
    ];

    perksGrid.innerHTML = T.perks.map((p, i) => `
      <div class="perk-item">
        <svg class="perk-icon" viewBox="0 0 24 24">${icons[i]}</svg>
        <div>
          <p class="perk-text__title">${p.title}</p>
          <p class="perk-text__sub">${p.sub}</p>
        </div>
      </div>
    `).join('');
  }

  setHTML('storyEyebrow', T.storyEyebrow);
  setHTML('storyTitle', T.storyTitle);
  setInner('storyBody1', T.storyBody1);
  setInner('storyBody2', T.storyBody2);

  const storyTags = d.getElementById('storyTags');
  if (storyTags) {
    storyTags.innerHTML = T.storyTags.map(tag => `<span class="story-tag">${tag}</span>`).join('');
  }

  setInner('storyCta1', T.storyCta1);
  setInner('storyCta2', T.storyCta2);

  setHTML('testiEyebrow', T.testiEyebrow);
  setHTML('testiTitle', T.testiTitle);

  const track = d.getElementById('testiTrack');
  if (track) {
    track.innerHTML = T.testimonials.map(r => `
      <div class="testimonial-card">
        <div class="testimonial-stars">★★★★★</div>
        <p class="testimonial-quote">${r.text}</p>
        <p class="testimonial-author">${r.author}</p>
      </div>
    `).join('');
  }

  setHTML('instaTitle', T.instaTitle);

  d.querySelectorAll('.insta-tile__overlay').forEach(el => {
    el.textContent = T.instaView;
  });

  setHTML('loyaltyEyebrow', T.loyaltyEyebrow);
  setHTML('loyaltyTitle', T.loyaltyTitle);
  setInner('loyaltyBody', T.loyaltyBody);

  const loyaltyStats = d.getElementById('loyaltyStats');
  if (loyaltyStats) {
    loyaltyStats.innerHTML = T.loyaltyStats.map(s => `
      <div class="loyalty-stat">
        <span class="loyalty-stat__num">${s.num}</span>
        <span class="loyalty-stat__label">${s.label}</span>
      </div>
    `).join('');
  }

  setInner('loyaltyCta', T.loyaltyCta);
  setInner('emailHint', T.emailHint);

  const emailInput = d.getElementById('emailInput');
  if (emailInput) {
    emailInput.placeholder = T.emailPlaceholder;
  }

  setInner('emailBtn', T.emailBtn);

  setInner('footerDesc', T.footerDesc);
  setInner('footerColShop', T.footerShop);
  setInner('footerColHelp', T.footerHelp);
  setInner('footerColCompany', T.footerCompany);

  renderLinks('footerShopLinks', T.footerShopLinks);
  renderLinks('footerHelpLinks', T.footerHelpLinks);
  renderLinks('footerCompanyLinks', T.footerCompanyLinks);

  setInner('footerCopy', T.footerCopy);

  setInner('cartTitle', T.cartTitle);
  setInner('cartCheckoutBtn', T.cartCheckout);
  setInner('cartSubtotalLabel', T.cartSubtotal);
  setInner('cartNote', T.cartNote);

  renderFooterDesc();
  applyTopbarSpeed();
}

/* ── SMALL HELPERS ── */
function setHTML(id, val) {
  const el = document.getElementById(id);
  if (el && val !== undefined) {
    el.innerHTML = val;
  }
}

function setInner(id, val) {
  const el = document.getElementById(id);
  if (el && val !== undefined) {
    el.textContent = val;
  }
}

function renderLinks(id, links) {
  const el = document.getElementById(id);

  if (!el || !Array.isArray(links)) {
    return;
  }

  el.innerHTML = links
    .filter(link => Array.isArray(link) && link.length >= 2 && link[0] && link[1])
    .map(([label, href]) => `<li><a href="${href}">${label}</a></li>`)
    .join('');
}

/* ── CART ── */
function refreshCart() {
  return fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Accept': 'application/json'
    }
  })
  .then(response => response.json())
  .then(shopifyCart => {
    cart.items = shopifyCart.items.map(item => {
      return {
        id: item.variant_id,
        key: item.key,
        name: item.product_title,
        price: item.final_price,
        img: item.image || '',
        qty: item.quantity,
        variant: item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '',
        product_url: item.url || ''
      };
    });

    cart.total = shopifyCart.total_price;

    updateCartUI();

    return shopifyCart;
  })
  .catch(error => {
    console.error('Could not refresh Shopify cart:', error);
    updateCartUI();
  });
}

function addToCart(prod, lng) {
  const name = lng === 'fr' ? prod.name_fr : prod.name_en;
  const existing = cart.items.find(i => i.id === prod.id && !i.key);

  if (existing) {
    existing.qty++;
  } else {
    cart.items.push({
      id: prod.id,
      key: 'local-' + prod.id,
      name,
      price: prod.price,
      img: prod.img,
      qty: 1,
      variant: 'One Size'
    });
  }

  cart.total = cart.items.reduce((s, i) => s + i.price * i.qty, 0);

  updateCartUI();
  openCart();
  showNotification(i18n[lng].addedToCart + ': ' + name);
}

function updateCartUI() {
  const T = i18n[lang];

  const count = cart.items.reduce((s, i) => s + i.qty, 0);

  document.querySelectorAll('.cart-count').forEach(el => {
    el.textContent = count;
    el.style.display = count ? 'flex' : 'none';
  });

  const body = document.getElementById('cartBody');
  if (!body) return;

  if (cart.items.length === 0) {
    body.innerHTML = `
      <div class="cart-empty">
        <svg viewBox="0 0 24 24"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
        <p>${T.cartEmpty}</p>
        <button class="btn btn--outline" onclick="closeCart()">${T.cartContinue}</button>
      </div>
    `;
  } else {
    body.innerHTML = cart.items.map(item => {
      const itemKey = item.key || String(item.id);
      const safeKey = itemKey.replace(/'/g, "\\'");

      return `
        <div class="cart-item">
          <img class="cart-item__img" src="${item.img}" alt="${item.name}" />

          <div class="cart-item__info">
            <p class="cart-item__name">${item.product_url ? `<a href="${item.product_url}">${item.name}</a>` : item.name}</p>
            ${item.variant ? `<p class="cart-item__variant">${item.variant}</p>` : ''}

            <div class="cart-item__row">
              <div class="qty-ctrl">
                <button type="button" onclick="changeQty('${safeKey}', -1)">−</button>
                <span>${item.qty}</span>
                <button type="button" onclick="changeQty('${safeKey}', 1)">+</button>
              </div>

              <span class="cart-item__price">${formatMoney(item.price * item.qty)}</span>
            </div>
          </div>
        </div>
      `;
    }).join('');
  }

  const amt = document.getElementById('cartTotalAmount');
  if (amt) {
    amt.textContent = formatMoney(cart.total);
  }

  const foot = document.getElementById('cartFoot');
  if (foot) {
    foot.style.display = cart.items.length ? 'block' : 'none';
  }
}

function changeQty(key, delta) {
  const item = cart.items.find(i => i.key === key || String(i.id) === String(key));

  if (!item) {
    return;
  }

  const newQty = Math.max(0, item.qty + delta);

  if (item.key && !item.key.startsWith('local-')) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: item.key,
        quantity: newQty
      })
    })
    .then(response => response.json())
    .then(() => refreshCart())
    .catch(error => {
      console.error('Could not change Shopify cart quantity:', error);
    });

    return;
  }

  item.qty = newQty;

  if (item.qty === 0) {
    cart.items = cart.items.filter(i => i.key !== key && String(i.id) !== String(key));
  }

  cart.total = cart.items.reduce((s, i) => s + i.price * i.qty, 0);

  updateCartUI();
}

/* ── DRAWERS ── */
function openCart() {
  const drawer = document.getElementById('cartDrawer');
  const overlay = document.getElementById('cartOverlay');

  if (drawer) drawer.classList.add('is-open');
  if (overlay) overlay.classList.add('is-open');
}

function closeCart() {
  const drawer = document.getElementById('cartDrawer');
  const overlay = document.getElementById('cartOverlay');

  if (drawer) drawer.classList.remove('is-open');
  if (overlay) overlay.classList.remove('is-open');
}

function openSearch() {
  const overlay = document.getElementById('searchOverlay');
  const input = document.getElementById('searchInput');

  if (overlay) overlay.classList.add('is-open');

  setTimeout(() => {
    if (input) input.focus();
  }, 100);
}

function closeSearch() {
  const overlay = document.getElementById('searchOverlay');

  if (overlay) overlay.classList.remove('is-open');
}

function openMobileNav() {
  const nav = document.getElementById('mobileNav');
  const overlay = document.getElementById('mobileOverlay');

  if (nav) nav.classList.add('is-open');
  if (overlay) overlay.classList.add('is-open');
}

function closeMobileNav() {
  const nav = document.getElementById('mobileNav');
  const overlay = document.getElementById('mobileOverlay');

  if (nav) nav.classList.remove('is-open');
  if (overlay) overlay.classList.remove('is-open');
}

/* ── NOTIFICATION ── */
function showNotification(msg) {
  const n = document.getElementById('notification');

  if (!n) {
    return;
  }

  const text = n.querySelector('.notif-text');

  if (text) {
    text.textContent = msg;
  }

  n.classList.add('show');

  setTimeout(() => {
    n.classList.remove('show');
  }, 3000);
}

/* ── ACCORDION ── */
function initAccordions() {
  document.querySelectorAll('.accordion-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const body = btn.nextElementSibling;
      const isOpen = btn.classList.contains('is-open');

      document.querySelectorAll('.accordion-btn').forEach(b => {
        b.classList.remove('is-open');

        if (b.nextElementSibling) {
          b.nextElementSibling.classList.remove('is-open');
        }
      });

      if (!isOpen && body) {
        btn.classList.add('is-open');
        body.classList.add('is-open');
      }
    });
  });
}

/* ── TESTIMONIALS DRAG ── */
function initTestiDrag() {
  const track = document.getElementById('testiTrack');

  if (!track) {
    return;
  }

  let isDown = false;
  let startX;
  let scrollLeft;

  track.addEventListener('mousedown', e => {
    isDown = true;
    startX = e.pageX - track.offsetLeft;
    scrollLeft = track.scrollLeft;
  });

  track.addEventListener('mouseleave', () => {
    isDown = false;
  });

  track.addEventListener('mouseup', () => {
    isDown = false;
  });

  track.addEventListener('mousemove', e => {
    if (!isDown) return;

    e.preventDefault();

    const x = e.pageX - track.offsetLeft;
    track.scrollLeft = scrollLeft - (x - startX);
  });
}

/* ── FOOTER DESCRIPTION from settings ── */
function renderFooterDesc() {
  const el = document.getElementById('footerDesc');

  if (!el) {
    return;
  }

  const currentLang = lang || 'en';
  const fallbackDesc = i18n[currentLang] && i18n[currentLang].footerDesc
    ? i18n[currentLang].footerDesc
    : i18n.en.footerDesc;

  const desc = el.dataset.desc || fallbackDesc || '';

  el.textContent = desc;
}

/* ── TOPBAR SCROLL SPEED from section settings ── */
function applyTopbarSpeed() {
  const track = document.getElementById('topbarTrack');

  if (!track) {
    return;
  }

  const speed = track.dataset.speed || 30;

  track.style.animationDuration = speed + 's';
}

/* ── INIT ── */
document.addEventListener('DOMContentLoaded', () => {
  renderPage();
  initAccordions();
  initTestiDrag();

  refreshCart();

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      closeSearch();
      closeCart();
      closeMobileNav();
    }
  });
});
